import { axiosPrivate } from '@/shared/api/axios'

const useAxiosPrivate = () => {
  // El interceptor global vive en el árbol protegido. Registrar otro por cada
  // componente duplicaba retries y podía reutilizar el refresh rotatorio v2.
  return axiosPrivate
}

export default useAxiosPrivate
